import { getApartmentCategoryCounts as o } from "../../metrics/apartment-distribution/index.js";
function e(t) {
  return o(t);
}
export {
  e as getStorySpecDistributionTotals
};
//# sourceMappingURL=index8.js.map
